import React, { useMemo, useState } from 'react';

import { Button, FormControl, InputLabel, MenuItem, Select, Stack } from '@mui/material';

import { BusinessSettingName } from '~/services/BusinessTraveller/BusinessTravellerService';

import { SETTING_LABELS, SETTING_NAMES } from '~/utils/businessTraveller/businessSettings';

interface Props {
  existingSettingNames: Array<BusinessSettingName>;
  onAdd: (settingName: BusinessSettingName) => void;
}

export default function AddBusinessSettingForm({ existingSettingNames, onAdd }: Props) {
  const [selected, setSelected] = useState<BusinessSettingName | undefined>();

  const availableNames = useMemo(
    () => SETTING_NAMES.filter((name) => !existingSettingNames.includes(name)),
    [existingSettingNames],
  );

  if (availableNames.length === 0) {
    return null;
  }

  const handleAdd = () => {
    if (!selected) {
      return;
    }

    onAdd(selected);
    setSelected(undefined);
  };

  return (
    <Stack direction="row" gap={2} alignItems="center">
      <FormControl size="small" sx={{ minWidth: 240 }}>
        <InputLabel id="add-business-setting-name-label">Setting</InputLabel>
        <Select
          labelId="add-business-setting-name-label"
          label="Setting"
          value={selected ?? ''}
          onChange={(event) => setSelected(event.target.value as BusinessSettingName)}
        >
          {SETTING_NAMES.map((name) => (
            <MenuItem key={name} value={name} disabled={existingSettingNames.includes(name)}>
              {SETTING_LABELS[name]}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      <Button variant="contained" color="primary" onClick={handleAdd} disabled={!selected}>
        Add setting
      </Button>
    </Stack>
  );
}
